import React, { useEffect, useState } from "react";
import { LogoImg } from "../../Constants/Images";
import { Link, useNavigate } from "react-router";

import IntroUserType from "./IntroUserType";
import AboutVanue from "./AboutVanue";
import SpaceInfos from "./SpaceInfos";
import { API } from "../../utils/Apis";
import { getLocalData, removeLocalData } from "../../utils/LocalStorage";
import AboutBusiness from "./AboutBusiness";
import useAuth from "../../Hooks/useAuth";

const AddSpacePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [formStep, setFormStep] = useState("introStep");
  const [venueInfo, setVenueInfo] = useState({});

  const [userTypes, setUserTypes] = useState([]);

  const skipStepItem = () => {
    if (formStep === "introStep" && userTypes && userTypes.length == 0) {
      setFormStep("aboutVanue");
    } else if (
      formStep === "introStep" &&
      userTypes &&
      userTypes.includes("Event Planner")
    ) {
      setFormStep("aboutBusiness");
    } else if (
      formStep === "introStep" &&
      userTypes &&
      !userTypes.includes("Event Planner")
    ) {
      setFormStep("aboutVanue");
    } else if (formStep === "aboutVanue") {
      if (user.type === "user") {
        navigate("/user/venues");

        removeLocalData("onBoardingSpaceID");
        removeLocalData("onBoardingVanueID");
      } else {
        navigate("/admin");

        removeLocalData("onBoardingSpaceID");
        removeLocalData("onBoardingVanueID");
      }

      // setFormStep("aboutVanue");
    }
  };

  const changeNextStep = (step: string) => {
    setFormStep(step);
  };

  const getVenueInfo = () => {
    const vanueId = getLocalData("onBoardingVanueID");

    if (vanueId) {
      API.getVanue(vanueId).then((res) => {
        if (res.type === "success") {
          console.log("Vanue :", res.data);
          setVenueInfo(res.data);
        }
      });
    }
  };

  useEffect(() => {
    getVenueInfo();
  }, []);

  return (
    <div className="add-space-wrapper">
      <div className="auth-page-header">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <Link to="/admin">
                <img src={LogoImg} alt="" className="logo-img" />
              </Link>
            </div>

            <div className="col-md-6 col-sm-6">&nbsp;</div>
          </div>
        </div>
      </div>

      <div className="add-space-form-wrapper">
        <div className="container">
          <div className="steps-nav-bredcrumb">
            <ul>
              {/* <li className={formStep !== "introStep" ? "active" : ""}>
                <span>B</span> About Your Business
              </li> */}
              <li className={formStep !== "introStep" ? "active" : ""}>
                <span>1</span> About Venue
              </li>
              <li className={formStep === "spaceInfoStep" ? "active" : ""}>
                <span>2</span> Spaces
              </li>
            </ul>
          </div>

          {formStep === "introStep" && (
            <IntroUserType
              changeNextStep={() => changeNextStep("aboutVanue")}
              skipStep={() => skipStepItem()}
              updateUserTypes={setUserTypes}
            />
          )}

          {formStep === "aboutBusiness" && (
            <AboutBusiness
              skipStep={() => skipStepItem()}
              changeNextStep={() => changeNextStep("aboutVanue")}
            />
          )}

          {formStep === "aboutVanue" && (
            <AboutVanue
              vanue={venueInfo}
              changeNextStep={() => changeNextStep("spaceInfoStep")}
              skipStep={() => skipStepItem()}
              setVenueInfo={setVenueInfo}
            />
          )}

          {formStep === "spaceInfoStep" && (
            <SpaceInfos
              venue={venueInfo}
              setStepBack={() => changeNextStep("aboutVanue")}
            />
          )}
        </div>
      </div>

      <div className="auth-footer-wrapper">
        <div className="container">
          <ul>
            <li>&copy; 2024 spacii</li>
            <li>
              <Link to="#">Terms of Service</Link>
            </li>
            <li>
              <Link to="#">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AddSpacePage;
